import React from 'react';
import { Plugin, CustomEditor } from '../types';

const LinkPlugin: Plugin = {
  name: 'link',
  
  commands: {
    insertLink: (editor: CustomEditor, url: string, text: string) => {
      // Create link element
      const linkElement = {
        type: 'paragraph' as const,
        children: [{
          text,
          link: url
        }]
      };
      
      // Insert link at current selection
      const { insertNode } = editor;
      insertNode(linkElement);
    }
  },

  renderLeaf: (props) => {
    const { attributes, children, leaf } = props;
    
    if (leaf.link) {
      return (
        <a 
          {...attributes} 
          href={leaf.link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#3b82f6', textDecoration: 'underline' }}
        >
          {children}
        </a>
      );
    }
    
    return undefined;
  }
};

export default LinkPlugin; 